module.exports = __webpack_public_path__ + "img/cnm_link_bg.1beac272.jpg";